import { Moment } from "moment/moment";
import { LinkObject } from "@teamprevent/common/model";
import * as moment from "moment";

import { Location, State as RouterState } from "redux-little-router";

export interface State {
    router: Location;
}

export type AppState = RouterState;

export enum OccupationalIllnessCategory {
    RespiratoryDisease = "Respiratory Disease (Category 1)",
    SkinDisease = "Skin Disease (Category 2)",
    UpperLimbDisorder = "Upper Limb Disorder (Category 3)",
    OtherMusculoskeletalDisorder = "Other Musculoskeletal Disorder (Category 4)",
    CancersAndMalignantBloodDiseases = "Cancers and Malignant Blood Diseases (Category 5)",
    Poisoning = "Poisoning (Category 6)",
    HearingLoss = "Hearing Loss (Category 7)",
    WorkRelatedTravelIllnesses = "Work Related Travel Illnesses (Category 8)",
    WorkRelatedStressIllnesses = "Work Related Stress Illnesses (Category 9)",
    AllOtherOccupationalIllnesses = "All Other Occupational Illnesses (Category 10)"
}

export enum InjuryOrIllness {
    Injury = "Injury",
    Illness = "Illness"
}

export enum DiagnosedOrSuspected {
    Diagnosed = "Diagnosed",
    Suspected = "Suspected",
    Undiagnosed = "Undiagnosed",
}

export interface OccupationalIllness extends CreateUpdateOccupationalIllness{
    readonly id?: string;
    readonly dateCreated: Moment | undefined;
    readonly dateModified: Moment | undefined;
    readonly description: string;
    readonly descriptionOfFurtherAction: string;
    readonly dateReportedToTheSheTeam: Moment | undefined;
    readonly illnessStarted: Moment | undefined;
    readonly hasBeenAbsent: boolean;
    readonly firstDayOfAbsence?: Moment;
    readonly lastDayOfAbsence?: Moment;
    readonly reported: boolean;
    readonly astraZenecaLocalSheReportableChange: boolean;
    readonly diagnosedOrSuspected: DiagnosedOrSuspected;
    readonly injuryOrIllness: InjuryOrIllness;
    readonly linkedOhCaseId: string;
    readonly ohCase: LinkObject;
    readonly employeeRecordId?: string;
    readonly completedById?: string;
    readonly completedByName?: string;
    readonly oshaReportable: boolean;
    readonly riddorReportable: boolean;
}

export interface CreateUpdateOccupationalIllness {
    readonly id?: string;
    readonly description: string;
    readonly descriptionOfFurtherAction: string;
    readonly dateReportedToTheSheTeam: Moment | undefined;
    readonly illnessStarted: Moment | undefined;
    readonly hasBeenAbsent: boolean;
    readonly firstDayOfAbsence?: Moment | undefined;
    readonly lastDayOfAbsence?: Moment | undefined;
    readonly reported: boolean;
    readonly astraZenecaLocalSheReportableChange: boolean;
    readonly diagnosedOrSuspected: DiagnosedOrSuspected | undefined;
    readonly injuryOrIllness: InjuryOrIllness | undefined;
    readonly linkedOhCaseId: string;
    readonly category: keyof typeof OccupationalIllnessCategory | undefined;
    readonly oshaReportable: boolean;
    readonly riddorReportable: boolean;
}

export interface OccupationalIllnessListModel {
    readonly id: string;
    readonly diagnosedOrSuspected: DiagnosedOrSuspected;
    readonly injuryOrIllness: InjuryOrIllness;
    readonly linkedOhCaseId: string;
    readonly oshaReportable: boolean;
    readonly riddorReportable: boolean;
    readonly category: keyof typeof OccupationalIllnessCategory;
}

/**
 * @deprecated Just use OhCaseListModel instead
 */
export interface OHCaseModel {
    id: string;
    caseType?: string;
    caseId?: string;
}

export const OccupationalIllnessCategoryOptions = (Object.keys(OccupationalIllnessCategory) as (keyof typeof OccupationalIllnessCategory)[]).map(key => {
    return {
        text: OccupationalIllnessCategory[key],
        value: key
    };
});

export const InjuryOrIllnessOptions = (Object.keys(InjuryOrIllness) as (keyof typeof InjuryOrIllness)[]).map(key => {
    return {
        text: InjuryOrIllness[key],
        value: key
    };
});

export const DiagnosedOrSuspectedOptions = (Object.keys(DiagnosedOrSuspected) as (keyof typeof DiagnosedOrSuspected)[]).map(key => {
    return {
        text: DiagnosedOrSuspected[key],
        value: key
    };
});

export const IsOccupationalIllnessValid = (model: CreateUpdateOccupationalIllness): boolean => {
    return !(!model.category ||
        !model.injuryOrIllness ||
        !model.diagnosedOrSuspected ||
        (model.dateReportedToTheSheTeam && model.dateReportedToTheSheTeam.isAfter(moment())) ||
        model.hasBeenAbsent && (
            (model.illnessStarted && model.illnessStarted.isAfter(moment())) ||
            (model.firstDayOfAbsence && model.firstDayOfAbsence.isAfter(moment())) ||
            (model.lastDayOfAbsence && model.lastDayOfAbsence.isAfter(moment())) ||
            (model.firstDayOfAbsence && model.firstDayOfAbsence.isAfter(model.lastDayOfAbsence)) ||
            (model.firstDayOfAbsence && model.illnessStarted && model.firstDayOfAbsence.isBefore(model.illnessStarted)) ||
            (model.firstDayOfAbsence && !model.illnessStarted)
        ));
};
